// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.doctor-stepper {
  padding: 0.25rem 0px 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 190px;
  margin: 0px auto;
}
.doctor-stepper__step {
  cursor: pointer;
  position: relative;
  flex: 0 0 1.25rem;
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  background: #F4981C;
  color: #FDFBFB;
  font-size: 0.625rem;
  font-weight: 700;
  font-family: "Filson Pro", sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
}
.doctor-stepper__step--active ~ .doctor-stepper__step {
  background: #00666F;
}
.doctor-stepper__step--active ~ .doctor-stepper__sep {
  background: #00666F;
}
.doctor-stepper__sep {
  flex: 1 1 auto;
  height: 2px;
  background: #F4981C;
}

@keyframes fadeInOpacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.doctor-form {
  display: none;
  height: 0px;
  opacity: 0;
  color: #007E94;
  background: rgba(253, 251, 251, 0.8);
  box-shadow: 0px -3px 6px 0px rgba(0, 0, 0, 0.1), 0px -11px 11px 0px rgba(0, 0, 0, 0.09), 0px -25px 15px 0px rgba(0, 0, 0, 0.05), 0px -44px 18px 0px rgba(0, 0, 0, 0.01), 0px -69px 19px 0px rgba(0, 0, 0, 0);
  transition: height 0.3s linear, opacity 0.3s linear;
}
.doctor-form--opened {
  opacity: 1;
  height: auto;
  display: block;
}
.doctor-form1 {
  opacity: 1;
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 0.4s;
}
.doctor-form2 {
  opacity: 1;
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 0.4s;
}
.doctor-form3 {
  opacity: 1;
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 0.4s;
}
.doctor-form__inner {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 0.5rem;
  padding: 0.5rem 0.5rem 0px;
}
.doctor-form__content {
  flex: 1 1 auto;
  max-height: 60vh;
  overflow: auto;
  /* Grid avec une seule cellule où tous les éléments se superposent */
  display: grid;
  grid-template-areas: "content";
}
.doctor-form__form {
  /* Tous les formulaires occupent la même cellule de grid */
  grid-area: content;
  /* Masqués par défaut */
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease;
}
.doctor-form__form--active {
  opacity: 1;
  visibility: visible;
}
.doctor-form__arrow {
  flex: 0 0 2rem;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  color: #00666F;
  font-size: 1.75rem;
  cursor: pointer;
}
.doctor-form__arrow--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.doctor-form__arrow [class^=icon-],
.doctor-form__arrow [class*=" icon-"] {
  display: block;
  transform: rotate(-90deg);
}
.doctor-form__row {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  gap: 1rem;
}
.doctor-form__left, .doctor-form__right {
  flex: 1 1;
}
.doctor-form__left {
  padding-right: 0.75rem;
}
.doctor-form__datas {
  padding: 0px;
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}
.doctor-form__datas .doctor-data-item {
  flex: 0 0 113px;
  gap: 10px;
  justify-content: flex-start;
}
.doctor-form__buttons {
  display: flex;
  gap: 1rem;
}
.doctor-form__buttons .button {
  flex: 1 1;
}
.doctor-form .button--medical {
  font-size: 0.875rem;
  padding: 0.375rem 1.5rem;
}
.doctor-form .button--medical [class^=icon-] {
  display: inline-block;
  margin-right: 0.5rem;
  position: relative;
  top: 2px;
}
.doctor-form .fieldset {
  margin: 0px;
}
@media (max-width: 767px), (max-height: 575px) {
  .doctor-form__arrow {
    flex: 0 0 1.75rem;
    font-size: 1.25rem;
  }
  .doctor-form__row {
    display: block;
  }
}

.doctor-form1 .fieldset-row {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  gap: 1rem;
}
.doctor-form1 .form-input {
  max-width: 243px;
}
.doctor-form1 .form-input--zipcode, .doctor-form1 .form-input--date {
  max-width: 133px;
}
.doctor-form1 .form-input--motif {
  max-width: 350px;
}
@media (max-width: 1199px) {
  .doctor-form1 .fieldset-row {
    display: block;
  }
}

.doctor-form4 .form-input__input {
  height: 5rem;
}

.doctor-data-item {
  list-style-type: none;
  padding: 0px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.25rem;
  font-size: 0.75rem;
  font-weight: 500;
}
.doctor-data-item__icon {
  font-size: 1.125rem;
  flex: 0 0 1.75rem;
  height: 1.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FDFBFB;
  border: 1px solid #007E94;
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/styles/components/DoctorForm.scss","webpack://./src/styles/abstracts/_variables.scss","webpack://./src/styles/abstracts/_functions.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAKhB;EACE,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;AAHF;AAKE;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBCTY;EDUZ,cCZW;EDaX,mBAAA;EACA,gBAAA;EACA,qCCgBY;EDfZ,aAAA;EACA,mBAAA;EACA,uBAAA;AAHJ;AAMM;EACE,mBCZc;ADQtB;AAMM;EACE,mBCfc;ADWtB;AAQE;EACE,cAAA;EACA,WAAA;EACA,mBC9BY;ADwBhB;;AAWA;EACC;IACC,UAAA;EARA;EAUD;IACC,UAAA;EARA;AACF;AAYA;EACE,aAAA;EACA,WAAA;EACA,UAAA;EACA,cC1CmB;ED2CnB,oCAAA;EACA,4MACE;EAKF,mDAAA;AAfF;AAiBE;EACE,UAAA;EACA,YAAA;EACA,cAAA;AAfJ;AAmBI;EACE,UAAA;EACA,6BAAA;EACA,4BAAA;EACA,kCAAA;EACA,wBAAA;AAjBN;AAYI;EACE,UAAA;EACA,6BAAA;EACA,4BAAA;EACA,kCAAA;EACA,wBAAA;AAVN;AAKI;EACE,UAAA;EACA,6BAAA;EACA,4BAAA;EACA,kCAAA;EACA,wBAAA;AAHN;AAOE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,0BAAA;AALJ;AAQE;EACE,cAAA;EACA,gBAAA;EACA,cAAA;EACA,oEAAA;EACA,aAAA;EACA,8BAAA;AANJ;AASE;EACE,0DAAA;EACA,kBAAA;EAEA,uBAAA;EACA,UAAA;EACA,kBAAA;EACA,6BAAA;AARJ;AAUI;EACE,UAAA;EACA,mBAAA;AARN;AAYE;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,cCzGkB;ED0GlB,kBAAA;EAEA,eAAA;AAXJ;AAaI;EACE,YAAA;EACA,mBAAA;AAXN;AAcI;;EAEE,cAAA;EACA,yBAAA;AAZN;AAgBE;EACE,aAAA;EACA,iBAAA;EACA,WAAA;EACA,SAAA;AAdJ;AAiBE;EAEE,SAAA;AAhBJ;AAmBE;EACE,sBAAA;AAjBJ;AAoBE;EACE,YAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;AAlBJ;AAoBI;EACE,eAAA;EACA,SAAA;EACA,2BAAA;AAlBN;AAsBE;EACE,aAAA;EACA,SAAA;AApBJ;AAsBI;EACE,SAAA;AApBN;AA2BE;EACE,mBAAA;EACA,wBAAA;AAzBJ;AA4BI;EACE,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,QAAA;AA1BN;AA6BE;EACE,WAAA;AA3BJ;AElHE;EFkJE;IACE,iBAAA;IACA,kBAAA;EA7BJ;EA+BE;IACE,cAAA;EA7BJ;AACF;;AAuCE;EACE,aAAA;EACA,iBAAA;EACA,WAAA;EACA,SAAA;AApCJ;AAuCE;EACE,gBAAA;AArCJ;AAuCI;EAEE,gBAAA;AAtCN;AAyCI;EACE,gBAAA;AAvCN;AElJE;EF8LE;IACE,cAAA;EAzCJ;AACF;;AA+CI;EACE,YAAA;AA5CN;;AAoDA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAjDF;AAmDE;EACE,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBCvQW;EDwQX,yBAAA;EACA,kBAAA;AAjDJ","sourcesContent":["@use '../abstracts/variables' as *;\n@use '../abstracts/functions';\n\n\n// -----------------------------------------------\n.doctor-stepper {\n  padding: 0.25rem 0px 0.75rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 190px;\n  margin: 0px auto;\n\n  &__step {\n    cursor: pointer;\n    position: relative;\n    flex: 0 0 1.25rem;\n    width: 1.25rem;\n    height: 1.25rem;\n    border-radius: 50%;\n    background: $color__orange;\n    color: $color__white;\n    font-size: 0.625rem;\n    font-weight: 700;\n    font-family: $font__ternary;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &--active ~ {\n      .doctor-stepper__step {\n        background: $color__primary-dark;\n      }\n      .doctor-stepper__sep {\n        background: $color__primary-dark;\n      }\n    }\n  }\n  &__sep {\n    flex: 1 1 auto;\n    height: 2px;\n    background: $color__orange;\n  }\n}\n\n\n@keyframes fadeInOpacity {\n\t0% {\n\t\topacity: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t}\n}\n\n// -----------------------------------------------\n.doctor-form {\n  display: none;\n  height: 0px;\n  opacity: 0;\n  color: $color__primary-alt;\n  background: rgba(253, 251, 251, 0.8);\n  box-shadow: \n    0px -3px 6px 0px rgba(0, 0, 0, 0.1), \n    0px -11px 11px 0px rgba(0, 0, 0, 0.09), \n    0px -25px 15px 0px rgba(0, 0, 0, 0.05), \n    0px -44px 18px 0px rgba(0, 0, 0, 0.01), \n    0px -69px 19px 0px rgba(0, 0, 0, 0);\n  transition: height 0.3s linear, opacity 0.3s linear;\n\n  &--opened {\n    opacity: 1;\n    height: auto;\n    display: block;\n  }\n\n  @for $i from 1 to 4 {\n    &#{$i} {\n      opacity: 1;\n      animation-name: fadeInOpacity;\n      animation-iteration-count: 1;\n      animation-timing-function: ease-in;\n      animation-duration: 0.4s;\n    }\n  }\n\n  &__inner {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    gap: 0.5rem;\n    padding: 0.5rem 0.5rem 0px;\n  }\n\n  &__content {\n    flex: 1 1 auto;\n    max-height: 60vh;\n    overflow: auto;\n    /* Grid avec une seule cellule où tous les éléments se superposent */\n    display: grid;\n    grid-template-areas: \"content\";\n  }\n\n  &__form {\n    /* Tous les formulaires occupent la même cellule de grid */\n    grid-area: content;\n    \n    /* Masqués par défaut */\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 0.3s ease;\n\n    &--active {\n      opacity: 1;\n      visibility: visible;\n    }\n  }\n\n  &__arrow {\n    flex: 0 0 2rem;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    justify-content: center;\n    color: $color__primary-dark;\n    font-size: 1.75rem;\n    // padding: 1rem 0px;\n    cursor: pointer;\n\n    &--disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n\n    [class^=\"icon-\"],\n    [class*=\" icon-\"] {\n      display: block;\n      transform: rotate(-90deg);\n    }\n  }\n\n  &__row {\n    display: flex;\n    flex-wrap: nowrap;\n    width: 100%;\n    gap: 1rem;\n  }\n\n  &__left,\n  &__right {\n    flex: 1 1;\n  }\n  \n  &__left {\n    padding-right: 0.75rem;\n  }\n\n  &__datas {\n    padding: 0px;\n    display: flex;\n    gap: 1rem;\n    flex-wrap: wrap;\n\n    .doctor-data-item {\n      flex: 0 0 113px;\n      gap:10px;\n      justify-content: flex-start\n    }\n  }\n\n  &__buttons {\n    display: flex;\n    gap: 1rem;\n\n    .button {\n      flex: 1 1;\n    }\n  }\n\n\n\n\n  .button--medical  {\n    font-size: 0.875rem;\n    padding: 0.375rem 1.5rem;\n\n    \n    [class^=\"icon-\"] {\n      display: inline-block;\n      margin-right: 0.5rem;\n      position: relative;\n      top: 2px;\n    }\n  }\n  .fieldset {\n    margin: 0px;\n  }\n  \n\n  @include functions.responsiveMobile {\n    &__arrow {\n      flex: 0 0 1.75rem;\n      font-size: 1.25rem;\n    }\n    &__row {\n      display: block;\n    }\n  }\n}\n\n\n\n\n// -----------------------------------------------\n.doctor-form1 {\n\n  .fieldset-row {\n    display: flex;\n    flex-wrap: nowrap;\n    width: 100%;\n    gap: 1rem;\n  }\n\n  .form-input {\n    max-width: 243px;\n\n    &--zipcode,\n    &--date {\n      max-width: 133px;\n    }\n\n    &--motif {\n      max-width: 350px;\n    }\n  }\n\n  @include functions.responsiveTablet {\n    .fieldset-row {\n      display: block;\n    }\n  }\n}\n\n.doctor-form4 {\n  .form-input {\n    &__input {\n      height: 5rem;\n    }\n  }\n}\n\n\n\n// -----------------------------------------------\n.doctor-data-item {\n  list-style-type: none;\n  padding: 0px;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.25rem;\n  font-size: 0.75rem;\n  font-weight: 500;\n\n  &__icon {\n    font-size: 1.125rem;\n    flex: 0 0 1.75rem;\n    height: 1.75rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: $color__white;\n    border: 1px solid $color__primary-alt;;\n    border-radius: 50%;\n  }\n}","// Screen sizes\n$screen-sm: 576px;\n$screen-md: 768px;\n$screen-lg: 992px;\n$screen-xl: 1200px;\n$screen-xxl: 1440px;\n$screen-full: 1920px;\n\n// Colors\n$color__white: #FDFBFB;\n$color__red: #FF4958;\n$color__orange: #F4981C;\n$color__black: #000000;\n$color_grey: #EEE7E1;\n$color-darkgrey: #697F8C;\n\n\n$color__primary: #1DADB5;\n$color__primary-alt: #007E94;\n$color__primary-dark: #00666F;\n$color__primary-light: #D3F1F2;\n\n$color__secondary-dark: #7D748D;\n$color__secondary: #ACA6B7;\n$color__secondary-light1: #E8E5EC;\n$color__secondary-light2: #F6F5F8;\n\n\n$color__ternary: #333c50;\n\n$theme__colors: (\n    \"primary\": $color__primary, \n    \"dark\": $color__black, \n    \"danger\": $color__red, \n    \"warning\": $color__orange\n);\n\n$font__primary: 'Exo', sans-serif;\n$font__secondary: 'Inter', sans-serif;\n\n$font__ternary: 'Filson Pro', sans-serif;\n$font__quaternary: 'Omnes', sans-serif;\n\n$size__text: 1rem;\n\n$font__text: $font__primary;\n$font__title: $font__primary;\n\n$border-radius1 : 10px;\n$border-radius2 : 15px;\n$border-radius3 : 20px;\n\n$marge1:5px;\n$marge2:10px;\n$marge3:5px;","@use './variables' as *;\n\n/// Base path for assets (fonts, images...),\n/// should not include trailing slash\n/// @access public\n/// @type String\n$asset-base-path: '../assets' !default;\n\n/// Asset URL builder\n/// @access private\n/// @param {String} $type - Asset type, matching folder name\n/// @param {String} $file - Asset file name, including extension\n/// @return {URL} - A `url()` function leading to the asset\n@function asset($type, $file, $before: '') {\n  @return url($before + $asset-base-path + '/' + $type + '/' + $file);\n}\n\n/// Image asset helper\n/// @access public\n/// @param {String} $file - Asset file name, including extension\n/// @return {URL} - A `url()` function leading to the image\n/// @require {function} asset\n@function image($file, $before: '') {\n  @return asset('images', $file, $before);\n}\n\n/// Image asset helper\n/// @access public\n/// @param {String} $file - Asset file name, including extension\n/// @return {URL} - A `url()` function leading to the image\n/// @require {function} asset\n@function picto($file, $before: '') {\n  @return asset('images/pictos', $file, $before);\n}\n\n/// Font asset helper\n/// @access public\n/// @param {String} $file - Asset file name, including extension\n/// @return {URL} - A `url()` function leading to the font\n/// @require {function} asset\n@function font($file, $before: '') {\n  @return asset('fonts', $file, $before);\n}\n\n\n// width < 1200px\n@mixin responsiveTablet {\n  @media (max-width: $screen-xl - 1px) {\n    @content;\n  }\n}\n\n// width < 768px OR height < 576px\n@mixin responsiveMobile {\n  @media (max-width: $screen-md - 1px), (max-height: $screen-sm - 1px) {\n    @content;\n  }\n}\n\n// width < 576px\n@mixin responsiveSmartphone {\n  @media (max-width: $screen-sm - 1px) {\n    @content;\n  }\n}\n\n@mixin responsiveWidth($width) {\n  @media (max-width: $width) {\n    @content;\n  }\n}\n\n@mixin responsiveHeight($height) {\n  @media (max-height: $height) {\n    @content;\n  }\n}\n\n@mixin responsiveWidthOrHeight($width, $height) {\n  @media (max-width: $width), (max-height: $height) {\n    @content;\n  }\n}\n\n@mixin responsiveNewTablet {\n  @include responsiveWidthOrHeight($screen-lg - 1px, 699px) {\n    @content;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
